import { HelpService } from './shared/help/help.service';
import { CmsDeliveryService } from './shared/cms-studio/cms-delivery.service';
import { languageInfo } from './shared/services/localization';
import { resourceText } from 'src/app/shared/services/localization';
import { Component, ElementRef, enableProdMode, OnInit, DOCUMENT } from '@angular/core';
import { AuthService } from './core/account/auth.service';
import { GlobalService } from './shared/services/global.service';
import { TenantService } from './tenant/tenant.service';
import { PLATFORM_ID, APP_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ChildrenOutletContexts, NavigationEnd, NavigationStart, Router, RouterEvent, RouterOutlet } from '@angular/router';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js'
import { slider } from './slider';
import { formatNumber, Location } from '@angular/common';
import { Event } from '@angular/router';


import {
  transition,
  trigger,
  query,
  style,
  animate,
  group,
  animateChild
} from '@angular/animations';
import { LocationStrategy } from '@angular/common';

import { filter } from 'rxjs/operators';
import { AppService } from './shared/services/app.service';
import { TenantResponse } from './tenant/tenant.model';
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';
import { Browser } from '@capacitor/browser';

declare global {
  interface Window {
    handlePushNotification: (payload: string) => void;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    slider
  ],
  standalone: false
})
export class AppComponent implements OnInit {
  disableAnimation: true;
  title = resourceText('GOTO_CHURCHSERVICES');
  isLoading: boolean = true;
  startupError='';
  retryStartup(){window.location.reload();}
  language: string = "en";
  simpleTenant: any;
  currentTenant: string;

  private readonly isAnimated: boolean = false;
  get desktopMenuPosition(){const doc=this.desktopDelivery.snapshot.value?.document;return doc?.desktopNavigation?.position||(doc?.website?.preset==='heritage'?'center':doc?.website?.preset==='modern'?'left':'top');}
  get contentDesigner(): boolean {
    return /\/content-studio(?:\/|$)/i.test(this.router.url.split(/[?#]/)[0]);
  }
  get wideWorkspace(): boolean {
    return /\/(?:content-studio|content|build-form|content-details|map-distribution|detailed-chart|outreach-chart|volunteering|my-volunteering)(?:\/|$)/i.test(this.router.url.split(/[?#]/)[0]);
  }
  get checkinPage(): boolean {
    return /\/(?:qr-self-checkin(?:-fixed(?:-group|-venue)?)?|fast-checkin)(?:\/|$)/i.test(this.router.url.split(/[?#]/)[0]);
  }
  get accountOnboarding(): boolean {
    const path = this.router.url.split(/[?#]/)[0];
    return path.endsWith('/signup') ||
      path.endsWith('/myprofile');
  }
  get accountMessagePage(): boolean {
    return /\/(?:email-access|validate|resetrequest|resetpassword|account-deletion)(?:\/|$)/i.test(this.router.url.split(/[?#]/)[0]);
  }
  public animationState: string;
  constructor(public help: HelpService,
    @Inject(DOCUMENT) private document: Document,
    public desktopDelivery:CmsDeliveryService,
    private authService: AuthService,
    public globalService: GlobalService,
    private tenantService: TenantService,
    private router: Router,
    private location: Location,
    private contexts: ChildrenOutletContexts,
    private el: ElementRef,
    private appService: AppService

  ) {


    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Ã¢Å“â€¦ reset AFTER full navigation completes
        this.globalService.isBack = false;
      }
    });

    // Prevent install PWA to home screen prompt
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the default browser prompt
      e.preventDefault();
    });

    window.handlePushNotification = (payload: string) => {
      const data = JSON.parse(payload);
      if (data.route) {
        this.router.navigate([data.route]); // Angular navigation
      }
    };

  }

  private clickHandler = (e: MouseEvent) => {
    // Components may handle a link themselves (for example, an embedded video).
    // Do not open a second browser/app after their preventDefault().
    if (e.defaultPrevented) return;
    const target = e.target instanceof Element ? e.target : null;
    const link = target?.closest('a');
    if (!link || !link.href) return;
    link.href=this.tenantService.browserLink(link.href);

    const isExternal =
      link.href.startsWith('http') &&
      !link.href.includes(window.location.host);

    if (isExternal) {
      e.preventDefault();
      Browser.open({ url: link.href });
    }
  };

  ngOnDestroy() {
    document.removeEventListener('click', this.clickHandler);
  }

  async ngOnInit() {
    this.isLoading = true;
    try{

    let tenant = '';
    const directCheckin = !this.tenantService.dedicatedDomain && window.location.pathname.match(/^\/([a-z0-9-]+)\/(?:qr-self-checkin(?:-fixed(?:-group|-venue)?)?|fast-checkin|signup|email-access)(?:\/|$)/i);
    // A direct link needs only its church; GetSimpleTenant still validates it server-side.
    let tenantList = directCheckin ? [directCheckin[1].toLowerCase()] : await this.tenantService.getAllTenantNames();
    this.tenantService.setTenantNames(tenantList);


    document.addEventListener('click', this.clickHandler);
    tenant = this.tenantService.getTenant();
    this.tenantService.configureManifest(tenant);

    if (tenant.toLowerCase().trim() != 'main') {
      localStorage.setItem('tenant', tenant);
      this.globalService.subdomain = tenant;
    }

    var defaultLanguage = localStorage.getItem('Language');
    if (defaultLanguage != null && defaultLanguage.trim() != "")
      this.language = languageInfo(defaultLanguage).code;

    this.globalService.SetRTL(this.globalService.currentLanguage);
    const tenantStartup = directCheckin ? this.tenantService.getSimpleTenant() : null;
    this.globalService.resourceArr = await this.globalService.getResources(
      this.globalService.currentLanguage
    );

    var localTenant = localStorage.getItem('tenant');
    localTenant = this.tenantService.canonicalAddress(localTenant);
    if(localTenant) localStorage.setItem('tenant',localTenant);
    if (tenant.toLowerCase().trim() == 'main')
      tenant = localTenant ?? '';

    if (localTenant?.toLowerCase().trim() == 'main' || (this.tenantService.tenantNamesCache?.includes(localTenant?.toLowerCase().trim()??"") == false))
    {
      localStorage.removeItem('tenant');
      localTenant = '';
      tenant = '';
    }

    if (tenant != null && tenant != "") {
      // if url tenant exists and different than localstorage tenant then switch and clear cache
      if (localTenant == null || localTenant.trim() == '' || ((localTenant != null && localTenant.trim() != "") &&
        (tenant.trim().toUpperCase() != localTenant.trim().toUpperCase()))) {
        if (tenant.toLowerCase().trim() != 'main') {
          localStorage.setItem('tenant', tenant);
          this.globalService.subdomain = tenant;
        }
        this.currentTenant = tenant;
        await this.appService.clearAllCaches();
        this.authService.logout(0);
      }
      else
        // if url tenant exists and is the same as localstorage tenant then just set subdomain and current to the same
        if ((tenant != null && tenant != "" && localTenant != null && localTenant.trim() != ""
          && tenant.trim().toUpperCase() == localTenant.trim().toUpperCase())) {
          this.globalService.subdomain = localTenant;
          this.currentTenant = localTenant;
        }
    }
    // if url tenant does not exist and localstorage tenant exists then set subdomain and current to the local
    else if (localTenant != null && localTenant.trim() != "") {
      this.globalService.subdomain = localTenant;
      this.currentTenant = localTenant;
    }
    else { 
      this.router.navigate(['main/switch-tenant']);
      this.isLoading = false;
      return;
    }
    // }

    this.router.events
      .pipe(
        filter((e: Event): e is NavigationStart => e instanceof NavigationStart)
      )
      .subscribe({
        next: (ev) => {
          if (!this.currentTenant || this.currentTenant.trim() === '') {
            this.currentTenant = localStorage.getItem('tenant')?.toLowerCase() || '';
          }

          let url = ev.url.toLowerCase();

          const segments = url.split('/').filter(x => x);
          const firstSegment = segments[0];

          const isTenantRoute =
            firstSegment &&
            this.tenantService.tenantNamesCache?.includes(firstSegment);

          if (
            this.currentTenant &&
            !this.tenantService.dedicatedDomain &&
            !isTenantRoute &&
            firstSegment !== 'main'
          ) {
            this.router.navigate([`/${this.currentTenant}`, ...segments]);
          }
        }
      });

    let url = window.location.pathname.toLowerCase();
    if (url === '/') url = '/home';

    const segments = url.split('/').filter(x => x);
    const firstSegment = segments[0];

    // Ã¢Å“â€¦ determine if first segment is a valid tenant
    const isTenantRoute =
      firstSegment &&
      this.tenantService.tenantNamesCache?.includes(firstSegment);

    if (
      this.currentTenant &&
      !this.tenantService.dedicatedDomain &&
      !isTenantRoute &&
      firstSegment !== 'main'
    ) {
      this.router.navigate([`/${this.currentTenant}`, ...segments]);
      this.isLoading = false;
      return;
    }

    this.globalService.mainSelector = this.el.nativeElement; //.querySelector('.main');
    this.simpleTenant = await (tenantStartup ?? this.tenantService.getSimpleTenant());
    if (!localStorage.getItem('Language')) {
      this.globalService.resourceArr = await this.globalService.getResources(this.simpleTenant.language || 'en');
      this.language = languageInfo(this.globalService.currentLanguage).code;
    }

    var csModule = this.simpleTenant.cmsModule;

    this.globalService.timeZone = this.simpleTenant.timeZoneDifference;


    if ((csModule == false) && (this.simpleTenant.subdomain.toLowerCase().trim() != "main") && (url.toUpperCase().trim().indexOf('VALIDATE') < 0) && (url.toUpperCase().trim().indexOf('HOME') < 0)
      && (url.toUpperCase().trim().indexOf('RESETPASSWORD') < 0) && (url.toUpperCase().trim().indexOf('SIGNUP') < 0)
      && (url.toUpperCase().trim().indexOf('FAST-CHECKIN') < 0) && (url.toUpperCase().trim().indexOf('FORMRENDER') < 0)
      && (url.toUpperCase().trim().indexOf('UNSUBSCRIBE') < 0) && (url.toUpperCase().trim().indexOf('ADD-POINT') < 0)
      && (url.toUpperCase().trim().indexOf('QR-SELF-CHECKIN') < 0) && (url.toUpperCase().trim().indexOf('QR-SELF-CHECKIN-FIXED') < 0) && (url.toUpperCase().trim().indexOf('QR-SELF-CHECKIN-FIXED-GROUP') < 0)
      && (url.toUpperCase().trim().indexOf('QR-SELF-CHECKIN-FIXED-VENUE') < 0)
      && (url.toUpperCase().trim().indexOf('NOTIFICATION') < 0) && (url.toUpperCase().trim().indexOf('NOTIFICATION') < 0)) {
      await this.authService.autoLogin(1);
    }

    if (this.simpleTenant.deleted == true) {
      this.router.navigate([this.currentTenant + '/service-notfound']);
      this.isLoading = false;
      return;
    }

    this.isLoading = false;
    if (directCheckin) void this.tenantService.getAllTenantNames().then(names => this.tenantService.setTenantNames(names)).catch(() => {});
    }catch{this.startupError=resourceText('CMS_STARTUP_UNAVAILABLE');}finally{this.isLoading=false;}
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet?.activatedRouteData?.['animation'];
    // return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }

  getRouteDataText() {
    return this.contexts?.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }

}
